import React from 'react';

interface TrashIconProps {
  size?: number;
  color?: string;
}

const TrashIcon: React.FC<TrashIconProps> = ({ 
  size = 24,
  color = "#666",
  ...props 
}) => {
return (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width="48px"
    height="48px"
    baseProfile="basic"
  >
    <linearGradient
      id="sYkP-pvQRBi-D-7I2ZY-za"
      x1="10"
      x2="39"
      y1="42.114"
      y2="42.114"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".462" stopColor="#c4c4c4" />
      <stop offset=".546" stopColor="#cdcdcd" />
      <stop offset=".635" stopColor="#808991" />
    </linearGradient>
    <path
      fill="url(#sYkP-pvQRBi-D-7I2ZY-za)"
      d="M39,39.64v1.416c0,0.422-0.266,0.799-0.663,0.942L27.97,45.703	c-0.629,0.225-1.314,0.233-1.949,0.024l-15.334-5.051C10.277,40.541,10,40.158,10,39.727V38.35l17,5.6L39,39.64z"
    />
    <linearGradient
      id="sYkP-pvQRBi-D-7I2ZY-zb"
      x1="6"
      x2="43.7"
      y1="24.32"
      y2="24.32"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".529" stopColor="#e6e6e6" stopOpacity=".7" />
      <stop offset=".577" stopColor="#b5b5b5" stopOpacity=".7" />
    </linearGradient>
    <polygon
      fill="url(#sYkP-pvQRBi-D-7I2ZY-zb)"
      points="27,16 6,9 10,38.35 22.18,34.22 27,35.77 39,39.64 43.7,10.4"
    />
    <linearGradient
      id="sYkP-pvQRBi-D-7I2ZY-zc"
      x1="6"
      x2="43.7"
      y1="9.645"
      y2="9.645"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".4" stopColor="#b5b5b5" stopOpacity=".6" />
      <stop offset=".471" stopColor="#e6e6e6" stopOpacity=".5" />
    </linearGradient>
    <polygon
      fill="url(#sYkP-pvQRBi-D-7I2ZY-zc)"
      points="43.7,10.4 27,16 6,9 22.18,3.29"
    />
    <linearGradient
      id="sYkP-pvQRBi-D-7I2ZY-zd"
      x1="10"
      x2="39"
      y1="39.085"
      y2="39.085"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".55" stopColor="#d5d8dc" />
      <stop offset=".615" stopColor="#bcbcbc" />
    </linearGradient>
    <polygon
      fill="url(#sYkP-pvQRBi-D-7I2ZY-zd)"
      points="39,39.64 27,43.95 10,38.35 22.18,34.22 27,35.77"
    />
    <path
      fill="#0471c7"
      d="M21.666,25.711l-2.557,0.73l2.018,4.169l1.106,0.402c0.367,0.126,0.596-0.027,0.876-0.397	c0.25-0.415,0.358-1.082,0.013-1.921l-0.025-0.077L21.666,25.711"
    />
    <path
      fill="#0471c7"
      d="M14.88,19.089c-0.571-0.208-1.234-0.217-1.602,0.271l-0.031,0.049l-1.123,1.976l2.771,2.669	l1.68-2.721l-0.709-1.447c-0.238-0.453-0.523-0.62-0.705-0.694l-0.228-0.083C14.916,19.103,14.898,19.096,14.88,19.089"
    />
    <path
      fill="#0471c7"
      d="M16.752,29.054l-3.911-1.423l-0.465,0.814L12.3,28.614c-0.077,0.262,0.004,0.587,0.216,1.065	l-0.147-0.303c0.242,0.679,0.855,1.606,1.771,2.041l0.064,0.031l2.559,0.931L16.752,29.054"
    />
    <path
      fill="#1594de"
      d="M18.708,28.559l-1.338,2.366l1.689,3.437l-0.061-1.192l1.795,0.653	c0.025,0.012,0.05,0.022,0.075,0.031c0.182,0.066,0.344,0.042,0.454-0.224l1.796-3.029c-0.003,0.004-0.007,0.008-0.01,0.013	c-0.28,0.37-0.509,0.523-0.876,0.397l-1.106-0.402l-2.344-0.853L18.708,28.559"
    />
    <path
      fill="#1594de"
      d="M15.11,19.172c-0.038-0.014-0.069-0.023-0.091-0.032l0.144,0.052	C15.143,19.185,15.126,19.178,15.11,19.172 M18.86,20.533c-0.033-0.012-0.067-0.023-0.104-0.032l-3.593-1.308	c0.182,0.075,0.467,0.242,0.705,0.694l0.709,1.447l1.217,2.484l-0.895,0.263l3.049,1.095l1.332-2.345l-0.909,0.25l-0.998-2.031	C19.279,20.826,19.143,20.636,18.86,20.533"
    />
    <path
      fill="#1594de"
      d="M13.135,23.285l-3.029-1.102l0.978,0.952l-0.797,1.386c-0.1,0.152-0.136,0.343,0.081,0.739	l2.001,4.117l0.147,0.303c-0.212-0.478-0.293-0.803-0.216-1.065c0.013-0.044,0.03-0.086,0.052-0.127l0.024-0.042l0.465-0.814	l1.035-1.812l0.984,0.939L13.135,23.285"
    />
    <path
      fill="#d5d8dc"
      d="M22.185,3.818l19.932,6.585L27,15.473L7.541,8.987L22.185,3.818 M22.18,3.29L6,9l21,7l16.7-5.6	L22.18,3.29L22.18,3.29z"
    />
  </svg>
);
};

export default TrashIcon;